import en from 'vee-validate/dist/locale/en.json';

export default {
  validation: en.messages,
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/vee-validate.js